<template>
  <legal-layout>
    <router-link
      class="legal-back"
      :to="{ name: 'legal' }"
    >
      <feather-icon
        icon="ArrowLeftIcon"
        size="16"
      />
      {{ $t('legal.center') }}
    </router-link>

    <section class="legal-card legal-report">
      <h1 class="legal-title">
        {{ $t('legal.report.title') }}
      </h1>
      <p class="legal-lead">
        {{ $t('legal.report.intro') }}
      </p>

      <div class="legal-report__grid">
        <section
          id="content"
          class="legal-report__box"
        >
          <h2>
            <feather-icon
              icon="FlagIcon"
              size="18"
            />
            {{ $t('legal.report.contentTitle') }}
          </h2>
          <p>{{ $t('legal.report.contentBody') }}</p>
          <a
            class="legal-report__mail"
            :href="mailto($t('legal.report.contentSubject'))"
          >
            <feather-icon
              icon="MailIcon"
              size="16"
            />
            {{ info.email }}
          </a>
        </section>

        <section
          id="illegal"
          class="legal-report__box legal-report__box--alert"
        >
          <h2>
            <feather-icon
              icon="AlertTriangleIcon"
              size="18"
            />
            {{ $t('legal.report.illegalTitle') }}
          </h2>
          <p>{{ $t('legal.report.illegalBody') }}</p>
          <a
            class="legal-report__mail"
            :href="mailto($t('legal.report.illegalSubject'))"
          >
            <feather-icon
              icon="MailIcon"
              size="16"
            />
            {{ info.email }}
          </a>
        </section>
      </div>

      <p class="legal-note">
        {{ $t('legal.report.handled') }}
        <router-link :to="{ name: 'legal.document', params: { slug: 'content-safety' } }">
          {{ $t('legal.docs.contentSafety') }}
        </router-link>
        ·
        <router-link :to="{ name: 'legal.document', params: { slug: 'child-safety' } }">
          {{ $t('legal.docs.childSafety') }}
        </router-link>
      </p>
    </section>
  </legal-layout>
</template>

<script>
import { LEGAL_INFO } from '@/libs/legal'
import LegalLayout from './LegalLayout.vue'

export default {
  name: 'LegalReport',
  components: { LegalLayout },
  data() {
    return { info: LEGAL_INFO }
  },
  watch: {
    '$route.hash': 'scrollToHash',
    '$i18n.locale': {
      immediate: true,
      handler() {
        document.title = `${this.$t('legal.report.title')} · ${this.info.brand}`
      },
    },
  },
  mounted() {
    this.scrollToHash()
  },
  methods: {
    mailto(subject) {
      return `mailto:${this.info.email}?subject=${encodeURIComponent(subject)}`
    },
    scrollToHash() {
      const id = (this.$route.hash || '').slice(1)
      if (!id) return
      this.$nextTick(() => {
        const el = document.getElementById(id)
        if (!el) return
        const top = el.getBoundingClientRect().top + window.pageYOffset - 80
        window.scrollTo({ top, behavior: 'smooth' })
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.legal-report__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 20px;
  margin-top: 26px;
}

.legal-report__box {
  padding: 22px;
  border: 1px solid rgba(150, 110, 255, 0.24);
  border-radius: 16px;
  background: rgba(15, 8, 38, 0.45);
  display: flex;
  flex-direction: column;
  gap: 12px;

  h2 {
    display: flex;
    align-items: center;
    gap: 10px;
    color: #fff !important;
    font-size: 18px;
    font-weight: 700;
    margin: 0;
  }

  p {
    margin: 0;
    line-height: 1.7;
    color: rgba(236, 232, 255, 0.85);
  }
}

.legal-report__box--alert {
  border-color: rgba(244, 114, 182, 0.45);
}

.legal-report__mail {
  align-self: flex-start;
  margin-top: auto;
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 9px 16px;
  border-radius: 999px;
  background: linear-gradient(135deg, #7c3aed, #ea03b2);
  color: #fff !important;
  font-weight: 600;
  font-size: 14px;
  word-break: break-all;
}

@media (max-width: 767px) {
  .legal-report__grid {
    grid-template-columns: 1fr;
  }
}
</style>
